import { render, staticRenderFns } from "./ed-deck-viewer-container.component.vue?vue&type=template&id=c01d472e&scoped=true&"
import script from "./ed-deck-viewer-container.component.ts?vue&type=script&lang=ts&"
export * from "./ed-deck-viewer-container.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-deck-viewer-container.component.scss?vue&type=style&index=0&id=c01d472e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01d472e",
  null
  
)

export default component.exports